module.exports = __webpack_public_path__ + "img/avatar-4.de759448.jpg";